<template>
  <div class="app-basic-min-width default-layout app-flex-column">
    <div class="main app-flex-column">
      <div class="brand-page">
        <div class="banner">
          <div class="content">
            <h3 class="title">微博品牌号</h3>
            <p class="desc">微博品牌营销工具，从公域传播到私域聚合营销升级</p>
            <div class="register-btn" @click="register()">申请开通</div>
            <a
              href="https://pinpaihao.biz.weibo.com/api/v1/brand/account/index/#/index"
              target="_blank"
              class="login-btn"
              >立即登录</a
            >
          </div>
        </div>
        <BrandKeypoint></BrandKeypoint>
        <BrandProduct @register="register"></BrandProduct>
        <BrandZhiyou></BrandZhiyou>
        <BrandPromotion></BrandPromotion>
        <BrandCase></BrandCase>
        <BrandPartner></BrandPartner>
        <div ref="contactInfo" class="contact-info brand-section">
          <div class="app-basic-layout-wrapper">
            <h3 class="title font-30">欢迎申请开通品牌号</h3>
            <h4 class="sub-title font-color-desc" style="color: #363636">
              品牌号注册开通及相关垂询，请留下您的联系方式，专属顾问会尽快与您联系
            </h4>
            <ContactInfo submit-text="立即申请开通" from="brand"></ContactInfo>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactInfo from '@/views/index/components/IndexContactInfo'
import BrandKeypoint from './components/BrandKeypoint'
import BrandProduct from './components/BrandProduct'
import BrandZhiyou from './components/BrandZhiyou'
import BrandPromotion from './components/BrandPromotion'
import BrandCase from './components/BrandCase'
import BrandPartner from './components/BrandPartner'

export default {
  components: {
    BrandKeypoint,
    BrandProduct,
    BrandZhiyou,
    BrandPromotion,
    BrandCase,
    BrandPartner,
    ContactInfo
  },
  methods: {
    register() {
      const { contactInfo } = this.$refs
      document.documentElement.scrollTop = contactInfo.offsetTop - 40
    }
  }
}
</script>

<style lang="scss" scoped>
.default-layout {
  min-height: 100vh;
  .main {
    flex: 1;
  }
}
.contact-info {
  padding-top: 64px;
  padding-bottom: 88px;
  background-color: #f4f5f7;
  .title {
    text-align: center;
    padding-bottom: 25px;
    margin-bottom: 28px;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 32px;
      height: 5px;
      background: $danger-color;
      border-radius: 2px;
    }
  }
  .sub-title {
    text-align: center;
    margin-bottom: 60px;
  }
}
.banner {
  background: url('~@/assets/img/brand/banner-bg.png') no-repeat center / cover;
  height: 640px;
  position: relative;
  .content {
    position: absolute;
    top: 221px;
    left: 128px;
  }
  .title {
    color: $text-color-yellow;
    font-size: 30px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    position: relative;
    &:after {
      content: '';
      background-color: $danger-color;
      width: 24px;
      height: 4px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  .desc {
    margin-bottom: 32px;
    font-size: 16px;
    color: #bb9d7d;
  }
  .register-btn {
    background-color: $text-color-yellow;
    cursor: pointer;
    text-align: center;
    width: 104px;
    height: 34px;
    line-height: 34px;
    border-radius: 17px;
    color: $text-color-gold;
    display: inline-block;
    margin-right: 24px;
    font-size: 14px;
  }
  .login-btn {
    color: $text-color-yellow;
    border: 1px solid $text-color-yellow;
    width: 104px;
    cursor: pointer;
    height: 34px;
    line-height: 34px;
    border-radius: 17px;
    display: inline-block;
    text-align: center;
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.brand-page {
  .brand-section {
    padding: 64px 0 88px;
    .title {
      padding-bottom: 20px;
      margin-bottom: 28px;
      position: relative;
      text-align: center;
      &:after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 32px;
        height: 5px;
        background: $text-color-copper;
        border-radius: 2px;
      }
    }
    .subtitle {
      margin-top: 12px;
      text-align: center;
      font-size: 16px;
    }
  }
  .index-contact-info-component {
    .left {
      .submit-box {
        .submit {
          background-color: $sub-color-4;
        }
      }
    }
    .right {
      .tel {
        color: $text-color-gold;
      }
    }
  }
}
</style>
